import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollapsibleSection } from './CollapsibleSection';

export const FAQAccordion: React.FC = () => {
  const { t } = useTranslation();

  const faqItems = [
    { questionKey: 'contactFaq.cancelSubscription.question', answerKey: 'contactFaq.cancelSubscription.answer' },
    { questionKey: 'contactFaq.certificate.question', answerKey: 'contactFaq.certificate.answer' },
    { questionKey: 'contactFaq.mobile.question', answerKey: 'contactFaq.mobile.answer' },
    { questionKey: 'contactFaq.official.question', answerKey: 'contactFaq.official.answer' },
    { questionKey: 'contactFaq.progress.question', answerKey: 'contactFaq.progress.answer' },
    { questionKey: 'contactFaq.planDifference.question', answerKey: 'contactFaq.planDifference.answer' },
    { questionKey: 'contactFaq.supportResponse.question', answerKey: 'contactFaq.supportResponse.answer' },
    { questionKey: 'contactFaq.freeTrial.question', answerKey: 'contactFaq.freeTrial.answer' },
    { questionKey: 'contactFaq.paymentMethods.question', answerKey: 'contactFaq.paymentMethods.answer' },
    { questionKey: 'contactFaq.accountSharing.question', answerKey: 'contactFaq.accountSharing.answer' },
  ];

  return (
    <div className="space-y-3">
      {faqItems.map((faq, index) => (
        <CollapsibleSection key={index} title={t(faq.questionKey)} defaultOpen={index === 0}>
          <p className="leading-relaxed text-slate-600">{t(faq.answerKey)}</p>
        </CollapsibleSection>
      ))}
    </div>
  );
};

export default FAQAccordion;
